module.exports = __webpack_public_path__ + "media/images/icon/mobile-fa16053ead31f81d3eec5039c6a40f29.svg";